export default "__VITE_ASSET__BDKXt7qG__"